import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgOpen = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M0.75 22.75H23.25"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.25 9.25H0.75"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.5 6.25L13.2 1.85C13.0603 1.66371 12.8791 1.5125 12.6708 1.40836C12.4625 1.30422 12.2329 1.25 12 1.25C11.7671 1.25 11.5375 1.30422 11.3292 1.40836C11.1209 1.5125 10.9397 1.66371 10.8 1.85L7.5 6.25"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.5 19.749V12.249"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.5 12.249H8.25C8.84674 12.249 9.41903 12.4861 9.84099 12.908C10.2629 13.33 10.5 13.9023 10.5 14.499C10.5 15.0957 10.2629 15.668 9.84099 16.09C9.41903 16.5119 8.84674 16.749 8.25 16.749H7.5"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3 12.25C2.60218 12.25 2.22064 12.408 1.93934 12.6893C1.65804 12.9706 1.5 13.3522 1.5 13.75V18.25C1.5 18.6478 1.65804 19.0294 1.93934 19.3107C2.22064 19.592 2.60218 19.75 3 19.75C3.39782 19.75 3.77936 19.592 4.06066 19.3107C4.34196 19.0294 4.5 18.6478 4.5 18.25V13.75C4.5 13.3522 4.34196 12.9706 4.06066 12.6893C3.77936 12.408 3.39782 12.25 3 12.25Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.5 19.749H15C14.6022 19.749 14.2206 19.591 13.9393 19.3097C13.658 19.0284 13.5 18.6468 13.5 18.249V13.749C13.5 13.3512 13.658 12.9696 13.9393 12.6883C14.2206 12.407 14.6022 12.249 15 12.249H16.5"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.5 16.749H16.5"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.5 19.749V12.249L22.5 19.749V12.249"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgOpen.displayName = 'SvgOpen';
export default SvgOpen;
